import { Amplify } from 'aws-amplify';

// This configuration uses Amplify v6 format
export const configureAmplify = () => {
  const config = {
    Auth: {
      Cognito: {
        region: process.env.REACT_APP_REGION || 'us-east-1',
        userPoolId: process.env.REACT_APP_USER_POOL_ID || 'us-east-1_qzlcHagq6',
        userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '6r6dl2evc44tdmnu75f7rdrg3f',
        loginWith: {
          oauth: {
            domain: process.env.REACT_APP_COGNITO_DOMAIN || `pocketpm-auth-dev.auth.${process.env.REACT_APP_REGION || 'us-east-1'}.amazoncognito.com`,
            scopes: ['openid', 'profile', 'email'],
                        redirectSignIn: [process.env.REACT_APP_REDIRECT_URL || window.location.origin],
            redirectSignOut: [process.env.REACT_APP_REDIRECT_URL || window.location.origin],
            responseType: 'code',
            providers: {
              AzureAD: {}
            }
          }
        }
      }
    }
  };

  Amplify.configure(config);
  return config;
};